import {inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, map, switchMap} from 'rxjs/operators';
import {of} from 'rxjs';
import * as GlobalConfigActions from './global-config.actions';
import {GlobalConfigService} from '../../utils/services/global-config.service';

@Injectable()
export class GlobalConfigEffects {
  private readonly actions$ = inject(Actions);
  private readonly service = inject(GlobalConfigService);

  loadConfig$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GlobalConfigActions.loadGlobalConfig),
      switchMap(() =>
        this.service.getConfig().pipe(
          map(config => GlobalConfigActions.loadGlobalConfigSuccess({config})),
          catchError(error => of(GlobalConfigActions.loadGlobalConfigFailure({error: error.message})))
        )
      )
    )
  );
}
